module.exports = __webpack_public_path__ + "portal-static/img/report.b36cc887.png";